import axios from 'axios';
import type {
	ExtraWorkRequest,
	ExtraWorkResponse,
	ExtraWorkOverviewQuery,
	ExtraWorkOverviewListResponse,
	ExtraWorkDetailsQuery,
	ExtraWorkDetailsListResponse,
} from '@/rennovation/planning-view/types/api/extra-work-response';

export class ReportApiService {
	private baseUrl = '/api/reports';

	async getReports(): Promise<ExtraWorkResponse[]> {
		const response = await axios.get<ExtraWorkResponse[]>(this.baseUrl);
		return response.data;
	}

	async getReportsByID(id: string): Promise<ExtraWorkResponse> {
		const response = await axios.get<ExtraWorkResponse>(`${this.baseUrl}/${id}`);
		return response.data;
	}

	/**
	 * Fetches all "Extra Work" reports associated with a specific Duty
	 */
	async getReportsByDuty(dutyID: string): Promise<ExtraWorkResponse[]> {
		const response = await axios.get<ExtraWorkResponse[]>(`${this.baseUrl}/duty/${dutyID}`);
		return response.data;
	}

	async createReport(report: Partial<ExtraWorkRequest>): Promise<ExtraWorkResponse> {
		const response = await axios.post<ExtraWorkResponse>(this.baseUrl, report);
		return response.data;
	}

	async editReport(id: string, payload: Partial<ExtraWorkRequest>): Promise<ExtraWorkResponse> {
		const response = await axios.patch<ExtraWorkResponse>(`${this.baseUrl}/${id}`, payload);
		return response.data;
	}

	async deleteReport(id: string, changeComment?: string | null): Promise<void> {
		await axios.delete(`${this.baseUrl}/${id}`, {
			data: { changeComment },
		});
	}

	async getOverviewReports(params: ExtraWorkOverviewQuery): Promise<ExtraWorkOverviewListResponse> {
		const response = await axios.get<ExtraWorkOverviewListResponse>(this.baseUrl, {
			params,
		});

		return response.data;
	}

	async getDetailReports(params: ExtraWorkDetailsQuery): Promise<ExtraWorkDetailsListResponse> {
		const response = await axios.get<ExtraWorkDetailsListResponse>(this.baseUrl, {
			params,
		});

		return response.data;
	}
}
